import React, { Component } from 'react';
import { DatePicker, List, Modal, Toast } from 'antd-mobile';

import df from 'dateformat';
import { ROOT_PATH } from '../../config';
import send from '../../utils/send';
import EmptyReport from '../../components/EmptyReport';
import LiveStockDetail from './liveStockDetails';
// import Gesture from '@antv/f2/lib/plugin/gesture';

// console.log(Gesture);
const F2 = require('@antv/f2/lib/index');
const Gesture = require('@antv/f2/lib/plugin/gesture');
const intervalSelect = require('@antv/f2/lib/interaction/interval-select');
const pieLabel = require('@antv/f2/lib/plugin/pie-label');
F2.Chart.plugins.register(Gesture);

let loading = 0;
const today = new Date();
let Shape = F2.Shape;
let Util = F2.Util;
let width = document.documentElement.clientWidth;

class LiveStock extends Component {
  constructor(props) {
    super(props);
    this.state = {
      salePigNoData: false,
      locationNoData: false,
      modalShow: false,
      modalHeader: '',
      modalContent: null,
      date: today,
      data: [] // 存栏信息和存栏变动信息
    };
  }
  getReport011 = (datas) => {
    const _self = this;
    // 要显示的字段。
    let keys = ['PURCHASE', 'TRN_IN', 'TRN_OUT', 'DEAD', 'CULL', 'SALE'];
    let groupNames = {
      PURCHASE: '采购',
      TRN_IN: '转入',
      TRN_OUT: '转出',
      SALE: '销售',
      DEAD: '死亡',
      CULL: '淘汰'
    };
    let data = []; // 数据源
    keys.map((key, index) => {
      let obj = {};
      datas.map((item) => {
        obj = {
          xName: item.LOCATION_NAME_LOC,
          groupName: groupNames[key],
          yName: item[keys[index]],
          locationId: item.LOCATION_ID
        };
        data.push(obj);
      });
    });
    let chart = this.chart1;
    if (chart) {
      // 当存在就清楚
      chart.clear();
    }
    chart = new F2.Chart({
      id: 'myChart1',
      plugins: intervalSelect,
      pixelRatio: window.devicePixelRatio
    });
    datas.map(function(item) {
      let total = item.PURCHASE + item.TRN_IN + item.TRN_OUT + item.DEAD + item.CULL + item.SALE;
      chart.guide().text({
        position: [item.LOCATION_NAME_LOC, total],
        content: total,
        offsetX: 0,
        offsetY: -8
      });
    });

    this.chart1 = chart;
    chart.source(data, {
      yName: {
        tickCount: 5
      }
    });

    chart.axis('yName', {
      line: null,
      grid: F2.Global._defaultAxis.grid,
      label: function(text) {
        return {
          text: parseInt(text)
        };
      }
    });
    chart.axis('xName', {
      line: F2.Global._defaultAxis.line,
      grid: null,
      label: (text) => {
        const cfg = {
          textAlign: 'center'
          // rotate:  -Math.PI / 10
        };
        cfg.text = text; // cfg.text 支持文本格式化处理
        if (text === '分娩舍仔猪') {
          cfg.text = '分娩舍\n仔猪';
        } else if (text === '保育舍小猪') {
          cfg.text = '保育舍\n仔猪';
        } else if (text === '育成舍肥猪') {
          cfg.text = '育成舍\n肥猪';
        }
        return cfg;
      }
    });
    chart.tooltip(false);
    let legendClicked = false;
    chart.legend('groupName', {
      align: 'center',
      itemWidth: 60, // 为了legend 一行 5个
      marker: {
        radius: 5
      },
      titleStyle: {
        fontSize: 14
      },
      onClick: function(ev) {
        // ******************** 将unchecked的数据项进行过滤 *************************
        const clickedItem = ev.clickedItem;
        const checked = !clickedItem.get('checked');
        const value = clickedItem.get('dataValue');
        const legends = chart.getLegendItems().groupName;
        const legendsChecked = {};
        legends.forEach((item) => {
          if (item.name === value) {
            legendsChecked[item.name] = checked;
          } else {
            legendsChecked[item.name] = item.checked;
          }
        });
        legendClicked = true;
        // 图表过滤掉unchecked数据
        chart.filter('groupName', (val) => {
          return legendsChecked[val];
        });
        // ***************************************************

        // **********************重绘 guide*****************************
        const sums = datas.map((obj) => {
          let counter = 0;
          counter += legendsChecked['采购'] ? obj.PURCHASE : 0;
          counter += legendsChecked['转入'] ? obj.TRN_IN : 0;
          counter += legendsChecked['转出'] ? obj.TRN_OUT : 0;
          counter += legendsChecked['死亡'] ? obj.DEAD : 0;
          counter += legendsChecked['淘汰'] ? obj.CULL : 0;
          counter += legendsChecked['销售'] ? obj.SALE : 0;
          return counter;
        });
        chart.guide().clear();
        datas.forEach((item, index) => {
          console.log(item.LOCATION_NAME_LOC, sums[index]);
          const offsetY = sums[index] > 0 ? -12 : 0;
          chart.guide().text({
            position: [item.LOCATION_NAME_LOC, sums[index]],
            content: sums[index],
            offsetX: 0,
            offsetY
          });
        });
        // 图标重绘
        chart.repaint();
      }
    });
    chart
      .interval()
      .position('xName*yName')
      .color('groupName', ['#1890FF', '#24C1B0', '#897DEC', '#FDB35E', '#F2E129', '#F26F11'])
      .adjust('stack')
      .size(20);
    chart.render();
    chart.interaction('interval-select', {
      mode: 'range',
      startEvent: 'tap',
      cancelable: false,
      selectStyle: null, // 被选中图形的样式配置
      unSelectStyle: null, // 未被选中图形的样式配置
      selectAxis: false, // 是否高亮坐标轴文本
      onStart: function(ev) {
        const { y } = Util.createEvent(ev, chart);
        if (y < 65) {
          return;
        }
        const { data } = ev;
        console.log(ev);
        if (typeof data === 'undefined' || legendClicked) {
          legendClicked = false;
          return;
        }
        _self.setState({
          modalShow: true,
          modalContent: <LiveStockDetail data={data.locationId} />
        });
      },
      onEnd() {
        chart.repaint();
      }
    });
  };
  getReport012 = (datas) => {
    const data = [];
    const obj = {
      BF: '期初',
      CF: '期末'
    };
    datas.forEach((item) => {
      Object.keys(obj).forEach((key) => {
        data.push({
          xName: item.LOCATION_NAME_LOC,
          qty: item[key],
          groupName: obj[key],
          locationId: item.LOCATION_ID
        });
      });
    });
    let chart = this.chart12;
    if (chart) {
      chart.changeData(data);
      return;
    }
    Shape.registerShape('interval', 'chart12-text', {
      draw(cfg, container) {
        var points = this.parsePoints(cfg.points);
        var style = Util.mix(
          {
            fill: cfg.color
          },
          cfg.style
        );
        var intervalShape = container.addShape('rect', {
          attrs: Util.mix(
            {
              x: points[1].x,
              y: points[1].y,
              width: points[2].x - points[1].x,
              height: points[0].y - points[1].y
            },
            style
          )
        });

        var origin = cfg.origin._origin; // 获取对应的原始数据记录
        var textShape = container.addShape('text', {
          zIndex: 1,
          attrs: {
            x: (points[1].x + points[2].x) / 2,
            y: points[1].y - 5, // 往上偏移 5 像素
            text: origin['qty'],
            fill: cfg.color || '#808080',
            textAlign: 'center',
            textBaseline: 'bottom',
            fontSize: 10 // 字体大小
          }
        });
        container.sort();
        return [intervalShape, textShape];
      }
    });
    chart = new F2.Chart({
      id: 'myChart12',
      plugins: Gesture,
      pixelRatio: window.devicePixelRatio
    });

    this.chart12 = chart;
    chart.source(data);
    chart.tooltip(false);
    chart.legend('groupName', {
      marker: {
        symbol: 'square',
        radius: 5
      },
      titleStyle: {
        fontSize: 14
      },
      align: 'center',
      itemWidth: 50
    });
    chart.axis('xName', {
      label: (text) => {
        const cfg = {
          fontSize: 10,
          textAlign: 'center'
        };
        cfg.text = text; // cfg.text 支持文本格式化处理
        if (text === '分娩舍仔猪') {
          cfg.text = '分娩舍\n仔猪';
        } else if (text === '保育舍小猪') {
          cfg.text = '保育舍\n仔猪';
        } else if (text === '育成舍肥猪') {
          cfg.text = '育成舍\n肥猪';
        } else if (text === '后备公猪') {
          cfg.text = '后备\n公猪';
        } else if (text === '后备母猪') {
          cfg.text = '后备\n母猪';
        }
        return cfg;
      }
    });
    chart
      .interval()
      .position('xName*qty')
      .color('groupName', ['#1890FF', '#FE5578'])
      .adjust({
        type: 'dodge',
        marginRatio: 0.2 // 两柱距离
      })
      .shape('chart12-text');
    chart.render();
    chart.pluginGesture({
      gesture: {
        tap: (data, ev) => {
          const point = Util.getRelativePosition(ev.center, chart.get('canvas'));
          let plot = chart.get('plotRange');
          const { x, y } = point;
          const { tl, tr, br } = plot;
          if (x >= tl.x && x <= tr.x && y >= tl.y && y <= br.y) {
            const record = chart.getRecord(point);
            const xName = record.xName;
            let locationId;
            data.forEach((item) => {
              let origin = item._origin;
              if (origin.xName === xName) {
                locationId = origin.locationId;
              }
            });
            this.setState({
              modalShow: true,
              modalContent: <LiveStockDetail data={locationId} />
            });
          }
        }
      }
    });
  };

  // 分周领
  getReport03 = (data3) => {
    // 计算总数
    const dataObj = data3[0];
    const sum = Object.values(dataObj).reduce((total, item) => total + item, 0);
    // 定义对应的中文，并用于规定颜色顺序
    let types = {
      PIG_QTY_BW24L: '<24周',
      PIG_QTY_BW24: '24周',
      PIG_QTY_BW25: '25周',
      PIG_QTY_BW26: '26周',
      PIG_QTY_BW27: '27周',
      PIG_QTY_BW28: '28周',
      PIG_QTY_BW29M: '>29周'
    };

    let arr = [];
    Object.keys(types).forEach((type) => {
      arr.push({
        memo: types[type],
        ratio: Number(dataObj[type] / sum).toFixed(2) * 1,
        amount: dataObj[type]
      });
    });
    const data = arr;
    let chart = this.chart3;
    if (chart) {
      chart.clear();
    } else {
      chart = new F2.Chart({
        id: 'myChart3',
        plugins: pieLabel,
        pixelRatio: window.devicePixelRatio
      });
    }
    this.chart3 = chart;
    chart.source(data);
    chart.coord('polar', {
      transposed: true,
      innerRadius: 0.4,
      radius: 0.55
    });
    chart.axis(false);
    chart.legend({
      itemWidth: 75,
      position: 'top',
      align: 'center',
      marker: {
        radius: 5
      },
      titleStyle: {
        fontSize: 14
      }
    });
    chart.tooltip(false);
    // 配置文本饼图
    chart.pieLabel({
      lineHeight: 45, // 行高
      label1OffsetY: -3, // label1 与连接线在垂直方向的偏移量
      label2OffsetY: 2,
      sidePadding: 40,
      activeShape: true, // 鼠标点击会不会凸起
      label1: function label1(data) {
        return {
          text: data.memo,
          fill: '#808080'
        };
      },
      label2: function label2(data) {
        return {
          fill: '#000',
          text: data.amount.toFixed(0) + '头',
          fontWeight: 500,
          fontSize: 10
        };
      }
    });
    chart
      .interval()
      .position('1*ratio')
      .color('memo', ['#008DFF', '#FF5276', '#24C1B0', '#897AEF', '#FFB455', '#F3E300', '#F83BAB'])
      .adjust('stack');
    chart.render();

    // 绘制内阴影
    var frontPlot = chart.get('frontPlot');
    var coord = chart.get('coord'); // 获取坐标系对象
    frontPlot.addShape('sector', {
      attrs: {
        x: coord.center.x,
        y: coord.center.y,
        r: coord.circleRadius * coord.innerRadius * 1.2, // 全半径
        r0: coord.circleRadius * coord.innerRadius,
        fill: '#000',
        opacity: 0.15
      }
    });
    chart.get('canvas').draw();
  };
  //  各舍存栏信息
  getData1 = (date) => {
    send(`${ROOT_PATH}/api/ifarm/v1/report/location`, {
      method: 'POST',
      data: {
        startDate: date,
        endDate: date,
        dateToday: date,
        gdType: ['D000201'],
        gdCode: ['1003'],
        command: 'getCommand1',
        startsWith: 1
      }
    }).then((res) => {
      loading++;
      let data = res.data[0].datas;
      this.setState({ locationNoData: data.length === 0 });
      this.getReport011(data);
      this.getReport012(data);
    });
  };
  // 分周龄可售肥猪分布
  getData3 = (date) => {
    send(`${ROOT_PATH}/api/ifarm/v1/report/sale_pig`, {
      method: 'POST',
      data: {
        startDate: date,
        endDate: date,
        dateToday: date,
        gdType: ['D000201'],
        gdCode: ['1002'],
        command: 'getCommand1',
        datasFlag: '2'
      }
    }).then((res) => {
      loading++;
      let sum = Object.values(res.data[0]).reduce((t, o) => t + o, 0);
      this.setState({ salePigNoData: sum === 0 });
      if (sum === 0) {
        return;
      }
      this.getReport03(res.data);
    });
  };

  doSearch = (date) => {
    Toast.loading('加载中...', 10);
    var d = df(date, 'yyyy-mm-dd');
    this.getData1(d);
    this.getData3(d);
  };
  componentDidMount() {
    loading = 0;
    window._czc && window._czc.push(['_trackEvent', '进入猪只存栏信息页面']);
    this.doSearch(new Date());
  }
  componentWillUnmount() {
    Toast.hide();
    this.setState = () => {};
  }
  componentWillUpdate() {}
  render() {
    loading === 2 && Toast.hide();
    return (
      <React.Fragment>
        <DatePicker
          extra="Optional"
          mode="date"
          onChange={(date) => {
            this.setState({ date });
            loading = 0;
            this.doSearch(date);
          }}
          title="日期"
          value={this.state.date}
        >
          <List.Item arrow="horizontal">选择日期</List.Item>
        </DatePicker>

        <List renderHeader={() => ''}>
          <span className="title">存栏信息</span>
          <div style={{ display: this.state.locationNoData ? 'none' : 'block' }}>
            <canvas height="360" id="myChart12" width={width} />
          </div>
          {this.state.locationNoData && <EmptyReport height={260} width={width} />}
        </List>
        <List renderHeader={() => ''}>
          <span className="title">存栏变动信息</span>

          <div style={{ display: this.state.locationNoData ? 'none' : 'block' }}>
            <canvas height="360" id="myChart1" width={width} />
          </div>
          {this.state.locationNoData && <EmptyReport height={260} width={width} />}

          {/*     {!this.state.locationNoData ? (
            <canvas height="360" id="myChart1" width={width} />
          ) : (
            <EmptyReport height={260} width={width} />
          )}*/}
        </List>

        {/*        <List renderHeader={() => ''}>
          <span className="title">存栏结构</span>
          <canvas height="260"
              id="myChart2"
              width={width}
          />
        </List>*/}

        <List renderHeader={() => ''}>
          <span className="title">分周龄可售肥猪分布</span>
          {this.state.salePigNoData ? (
            <EmptyReport height={260} width={width} />
          ) : (
            <canvas height="360" id="myChart3" width={width} />
          )}
        </List>

        <Modal
          animationType="slide-up"
          maskClosable={false}
          closable
          onClose={() => {
            this.setState({
              modalShow: false
            });
          }}
          popup
          visible={this.state.modalShow}
        >
          {this.state.modalContent}
        </Modal>
      </React.Fragment>
    );
  }
}

export default LiveStock;
